export type PageSlideDirection = 'forward' | 'back';

export type PageNavigationType = 'POP' | 'PUSH' | 'REPLACE';

const normalizePath = (path: string): string => {
  if (path === '/') {
    return path;
  }

  return path.replace(/\/+$/, '') || '/';
};

/**
 * Returns true when `ancestor` is a strict path prefix of `descendant`.
 * Segment boundaries are enforced so `/sites` does not match `/sites-other`.
 */
export const isPathAncestor = (
  ancestor: string,
  descendant: string,
): boolean => {
  const normalizedAncestor = normalizePath(ancestor);
  const normalizedDescendant = normalizePath(descendant);

  if (normalizedAncestor === normalizedDescendant) {
    return false;
  }

  return normalizedDescendant.startsWith(`${normalizedAncestor}/`);
};

/**
 * Resolves horizontal page slide direction for nested tab routes.
 *
 * - Browser/history back (`POP`) uses the pop animation (`forward`).
 * - Navigating to an ancestor path (e.g. tab re-tap to section root) also
 *   uses the pop animation, even when React Router records a `PUSH`.
 * - All other navigations use the drill-in animation (`back`).
 */
export const resolvePageSlideDirection = (
  navigationType: PageNavigationType,
  fromPath: string,
  toPath: string,
): PageSlideDirection => {
  if (navigationType === 'POP') {
    return 'forward';
  }

  if (isPathAncestor(toPath, fromPath)) {
    return 'forward';
  }

  return 'back';
};
